var React = require('react');

function ContentPlayHollow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-play-hollow"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M31,61.88A30.88,30.88,0,1,1,61.88,31,30.92,30.92,0,0,1,31,61.88Zm0-60A29.13,29.13,0,1,0,60.13,31,29.15,29.15,0,0,0,31,1.88ZM23.63,43V19L44.24,31Zm1.75-21V40l15.38-9Z","key":0}),React.createElement("g",{"key":1},[React.createElement("polygon",{"points":"24.38 41.38 42.38 30.88 24.38 20.38 24.38 41.38","key":0}),React.createElement("path",{"d":"M24,42.37V19.63L43.49,31Zm1-21V40.63L41.51,31Z","key":1})])])]);
}

ContentPlayHollow.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 61.75 61.75"};

module.exports = ContentPlayHollow;

ContentPlayHollow.default = ContentPlayHollow;
